import React, { useEffect, useState } from "react";
import { AxiosResponse } from "axios";

import {
  activityToActivityRelation,
  Result,
  Group,
} from "../../interface/activityToActivityRelation";
import { ActivityToActivityRelationAxiosInstance } from "../../Network/ActivityToActivityRelationAxiosInstance";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "shared/DataTable";
import { Button } from "../../components/ui/button";
import Joi from "joi";
const ActivityToActivityRelation: React.FC = () => {
  const [items, setItems] = useState<activityToActivityRelation>({
    result: [],
  });
  const [firstGroup, setfirstGroup] = useState<Group>({
    activity_codes: [],
    custom_activity_groups: [],
    medical_activity_groups: [],
  });

  const [secondGroup, setsecondGroup] = useState<Group>({
    activity_codes: [],
    custom_activity_groups: [],
    medical_activity_groups: [],
  });

  const [errorId, seterrorId] = useState<number | null>(0);
  const [IdError, setIdError] = useState<string>("");
  const token = localStorage.getItem('token') || "";

  const [editIndex, setEditIndex] = useState<null | number>(null);
  const Erroridschema = Joi.string().allow("") // Allow empty string
  .regex(/^\d+$/)
  .messages({
    "string.pattern.base": "Please enter only numbers",
  });

  //............................................. get data .................................................

  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await ActivityToActivityRelationAxiosInstance.get(
          "GetALLActivityToActivityRelation"
        );

      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  //............................................. end get data ...............................................
  //............................................. add data ...............................................

  const handleErrorIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
  // check the entry using Joi
    const { error } = Erroridschema.validate(value);
  
    if (error) {
      setIdError(error.message); 
    } else {
      setIdError(""); 
      const inputValue = e.target.value.trim();
      seterrorId(inputValue !== "" ? parseInt(inputValue) : null)
     }
  };

  const addItem = async (): Promise<void> => {
    try {
      const newActivityToActivityRelation = {
        firstGroup: firstGroup,
        secondGroup: secondGroup,
        errorId: errorId,
        token: token,
      };

      await ActivityToActivityRelationAxiosInstance.post(
        "addActivityTOActivityRelation",
        newActivityToActivityRelation
      );
      fetchItems();
      setfirstGroup({
        activity_codes: [],
        custom_activity_groups: [],
        medical_activity_groups: [],
      });
      setsecondGroup({
        activity_codes: [],
        custom_activity_groups: [],
        medical_activity_groups: [],
      });
      seterrorId(0);

      console.log(
        "New group Added Successfully:",
        newActivityToActivityRelation
      );

      console.log(items);
    } catch (error) {
      console.error("Error adding item:", error);
    }
  };
  useEffect(() => {
    fetchItems();
  }, []);
  //.............................................end add data ...............................................

  // ..................................................update data...............................
  const updateItem = async (id: string | number): Promise<void> => {
    try {
      const updatedItem = {
        first_group: firstGroup,
        second_group: secondGroup,
        error_id: errorId,
        id: id,
        token: token,
      };

      await ActivityToActivityRelationAxiosInstance.put(
        `updateActivityTOActivityRelation`,
        updatedItem
      );
      fetchItems();

      setfirstGroup({
        activity_codes: [],
        custom_activity_groups: [],
        medical_activity_groups: [],
      });
      setsecondGroup({
        activity_codes: [],
        custom_activity_groups: [],
        medical_activity_groups: [],
      });
      seterrorId(0);
      console.log("New group updated successfully:", updatedItem);
    } catch (error) {
      console.error("Error updating item:", error);
    }
  };

  //.............................................end update data ...............................................
  //............................................. remove data ...............................................

  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await ActivityToActivityRelationAxiosInstance.delete(
        `deleteActivityTOActivityRelation/${id}`, {
          
           data: { token: token }, 
         }
      );
      console.log(id);
      fetchItems();
    } catch (error) {
      console.error("Error removing item:", error);
    }
  };
  //.............................................end remove data ...............................................


  const resetForm = () => {
    setfirstGroup({
      activity_codes: [],
      custom_activity_groups: [],
      medical_activity_groups: [],
    });
    setsecondGroup({
      activity_codes: [],
      custom_activity_groups: [],
      medical_activity_groups: [],
    });
    seterrorId(0);
    setEditIndex(null);

  };
  const handleEdit =  (item: Result) => {
    setfirstGroup(item.first_group);
    setsecondGroup(item.second_group);
    seterrorId(item.error_id);
    setEditIndex(item.id);

  }
  
  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
   
    {
      accessorKey: "first_group",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
FirstGroup
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const FirstGroup = row.getValue("first_group") as string[];
        return Array.isArray(FirstGroup) ? FirstGroup.join(", ") : FirstGroup;
      },
    },
 {
      accessorKey: "second_group",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >SecondGroup
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const SecondGroup = row.getValue("second_group") as string[];
        return Array.isArray(SecondGroup) ? SecondGroup.join(", ") : SecondGroup;
      },
    },
    {
      accessorKey: "error_id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 ErrorId
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
  ];


  return (
    <div className=" container" style={{ margin: "30px" }}>
      {/* title */}
      <h5>
        Activity To Activity Relation Screen{" "}
        <span>
          {" "}
          <i className="fa-solid fa-briefcase"></i>{" "}
        </span>{" "}
      </h5>
    
      {/* model */}
      {/* tabIndex="-1" */}
      <div
        className="modal fade"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Item
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {" "}
              </button>
            </div>

            <div className=" container d-flex flex-column align-items-center ">
              <div>
                <label className="m-2">First Group :</label>

                {/* Input for activity_codes */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">Activity Codes:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={firstGroup.activity_codes.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => item.trim());
                      setfirstGroup((prevState) => ({
                        ...prevState,
                        activity_codes: values,
                      }));
                    }}
                  />
                </div>

                {/* Input for custom_activity_groups */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">Custom Activity Groups:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={firstGroup.custom_activity_groups.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => Number(item.trim()));
                      setfirstGroup((prevState) => ({
                        ...prevState,
                        custom_activity_groups: values,
                      }));
                    }}
                  />
                </div>

                {/* Input for medical_activity_groups */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">Medical Activity Groups:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={firstGroup.medical_activity_groups.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => item.trim());
                      setfirstGroup((prevState) => ({
                        ...prevState,
                        medical_activity_groups: values,
                      }));
                    }}
                  />
                </div>
              </div>

              <div>
                <label className="m-2">Second Group :</label>

                {/* Input for activity_codes */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">Activity Codes:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={secondGroup.activity_codes.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => item.trim());
                      setsecondGroup((prevState) => ({
                        ...prevState,
                        activity_codes: values,
                      }));
                    }}
                  />
                </div>

                {/* Input for custom_activity_groups */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">Custom Activity Groups:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={secondGroup.custom_activity_groups.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => Number(item.trim()));
                      setsecondGroup((prevState) => ({
                        ...prevState,
                        custom_activity_groups: values,
                      }));
                    }}
                  />
                </div>

                {/* Input for medical_activity_groups */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">Medical Activity Groups:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={secondGroup.medical_activity_groups.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => item.trim());
                      setsecondGroup((prevState) => ({
                        ...prevState,
                        medical_activity_groups: values,
                      }));
                    }}
                  />
                </div>
              </div>
<div>
              <label className="m-2 ">Error ID :</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px"}}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={errorId !== null ? errorId.toString() : ""}
                onChange={handleErrorIdChange}
                />
                {IdError && <div style={{ color: "red" }}>{IdError}</div>}
  
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={
                  editIndex === null ? addItem : () => updateItem(editIndex)
                }
              >
                {editIndex === null ? "Add Item" : "Update Item"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={resetForm}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* table */}
      <DataTable
  columns={columns}
  data={items.result}
  searchColumn="first_group"
  addButtonLabel="Add New Relation" // Custom button text
  modalId="exampleModal" // Custom add modal ID
  showAddButton={true} // Control visibility
  onEdit={handleEdit}
  onDelete={removeItem}
/>
    </div>
  );
};
export default ActivityToActivityRelation;
